import { render, staticRenderFns } from "./CourseHandout.vue?vue&type=template&id=29cedfcc&scoped=true"
import script from "./CourseHandout.vue?vue&type=script&lang=js"
export * from "./CourseHandout.vue?vue&type=script&lang=js"
import style0 from "./CourseHandout.vue?vue&type=style&index=0&id=29cedfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cedfcc",
  null
  
)

export default component.exports